<div id="main-body">
    <h4 style="text-align: center; margin-bottom: 5%; margin-top: 5%;">Διαχείριση Θέσεων Εργασίας</h4>

    <div class="nav-table">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{active:selectedTab === 'pending'}" id="pending-tab" data-toggle="tab" (click)="changeTabOption('pending')" href="#pending" role="tab" aria-controls="pending" aria-selected="true">Νέες Θέσεις</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{active:selectedTab === 'approved'}" id="approved-tab" data-toggle="tab" (click)="changeTabOption('approved')" href="#approved" role="tab" aria-controls="approved" aria-selected="false">Εγκεκριμένες Θέσεις</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{active:selectedTab === 'disapproved'}" id="disapproved-tab" data-toggle="tab" (click)="changeTabOption('disapproved')" href="#disapproved" role="tab" aria-controls="disapproved" aria-selected="false">Απορριφθείσες Θέσεις</a>
            </li>
        </ul>

        <div class="tab-content" id="myTabContent">
            <!-- pending jobPosts -->
            <div *ngIf="jobPostsData" class="tab-pane fade show" [ngClass]="{active:selectedTab === 'pending'}" id="pending" role="tabpanel" aria-labelledby="home-tab">
                <table id="jobPostsTable" *ngIf="jobPostsData" class="table">
                    <thead>
                        <tr class="table-success">
                            <th style="width: 5%" class="th-content">
                                <label *ngIf="jobPostsData.length > 0" class="checkBoxContainer">
                                    <input class="checkBoxInputs" type="checkbox" [checked]="isAllSelected"
                                        (change)="onCheckboxChangeSelectAll($event)" />
                                    <span class="checkmark"></span>
                                </label>
                            </th>
                            <th style="width: 20%" class="th-content">Τιτλος</th>
                            <th style="width: 20%" class="th-content">Επωνυμια εταιρειας</th>
                            <th style="width: 15%" class="th-content">Ημ/νια αναρτησης</th>
                            <th style="width: 15%" class="th-content">Ημ/νια Ληξης</th>
                            <th style="width: 10%" class="th-content">θεση</th>
                            <th style="width: 15%" class="th-content">Κατασταση</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let jobPost of jobPostsData">
                            <td> <label class="checkBoxContainer">
                                    <input class="checkBoxInputs" type="checkbox" [checked]="jobPost.selected"
                                        [value]="jobPost.uuid" (change)="onCheckboxChange($event)" />
                                    <span class="checkmark"></span>
                                </label> </td>
                            <td>{{jobPost.title}}</td>
                            <td>{{jobPost.companyName}}</td>
                            <td>{{jobPost.creationDate|date: 'mediumDate'}}</td>

                            <td><span *ngIf="jobPost.expirationDate; else notExists">{{jobPost.expirationDate|date: 'mediumDate'}}</span>
                            </td>
                            <td class="link" (click)="jobPostDetails(jobPost.uuid)">
                                Περισσότερες Πληροφορίες
                            </td>
                            <td style="width: 100%;">
                                <select (change)="onChange($event, jobPost.uuid)" class="form-control" id="sel1" name="sellist1" style="width: max-content;">
                                    <option value="pending" selected>Εκκρεμής</option>
                                    <option value="approved">Εγκρίνεται</option>
                                    <option value="disapproved">Απορρίπτεται</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <p *ngIf="jobPostsData.length===0" style="margin-top: 20px;"> {{message}}</p>

                <div *ngIf="jobPostsData.length>0" class="container handlingmultiplebuttons">
                    <div class="row ">
                        <div class="col-md-4 col-12 text-center">
                            <button type="button" (click)="confirmModal('approved')" class="btn btn-approve btn-width">Έγκριση
                                επιλεγμένων</button>
                        </div>
                        <div class="col-md-4 offset-md-4 col-12 text-center ">
                            <button type="button" (click)="confirmModal('disapproved')" class="btn btn-disapprove btn-width">Απόρριψη
                                επιλεγμένων</button>
                        </div>
                    </div>
                    <br />
                </div>
            </div>

            <!-- approved jobPosts -->
            <div *ngIf="jobPostsData" class="tab-pane fade show" [ngClass]="{active:selectedTab === 'approved'}" id="approved" role="tabpanel" aria-labelledby="profile-tab">

                <table id="jobPostsTable" class="table">
                    <thead>
                        <tr>
                            <th style="width: 20%" class="th-content">Τιτλος</th>
                            <th style="width: 20%" class="th-content">Επωνυμια εταιρειας</th>
                            <th style="width: 15%" class="th-content">Ημ/νια αναρτησης</th>
                            <th style="width: 15%" class="th-content">Ημ/νια ληξης</th>
                            <th style="width: 15%" class="th-content">θεση</th>
                            <th style="width: 15%" class="th-content">Κατασταση</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let jobPost of jobPostsData">
                            <td>{{jobPost.title}}</td>
                            <td>{{jobPost.companyName}}</td>

                            <td>{{jobPost.creationDate|date: 'mediumDate'}}</td>
                            <td><span *ngIf="jobPost.expirationDate; else notExists">{{jobPost.expirationDate|date: 'mediumDate'}}</span>
                            </td>

                            <td class="link" (click)="jobPostDetails(jobPost.uuid)">
                                Περισσότερες Πληροφορίες
                            </td>

                            <td style="width: 100%;">
                                <select (change)="onChange($event, jobPost.uuid)" class="form-control" id="sel1" name="sellist1" style="width: max-content;">
                                    <option value="pending">Εκκρεμής</option>
                                    <option value="approved" selected>Εγκρίνεται</option>
                                    <option value="disapproved">Απορρίπτεται</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p *ngIf="jobPostsData.length===0" style="margin-top: 20px;"> {{message}}</p>
            </div>

            <!-- dissaproved jobPosts -->
            <div *ngIf="jobPostsData" class="tab-pane fade show" [ngClass]="{active:selectedTab === 'disapproved'}" id="disapproved" role="tabpanel" aria-labelledby="contact-tab">
                <table id="jobPostsTable" class="table">
                    <thead>
                        <tr>
                            <th style="width: 20%" class="th-content">Τιτλος</th>
                            <th style="width: 20%" class="th-content">Επωνυμια εταιρειας</th>
                            <th style="width: 15%" class="th-content">Ημ/νια αναρτησης</th>
                            <th style="width: 15%" class="th-content">Ημ/νια ληξης</th>
                            <th style="width: 15%" class="th-content">θεση</th>
                            <th style="width: 15%" class="th-content">Κατασταση</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let jobPost of jobPostsData">
                            <td>{{jobPost.title}}</td>
                            <td>{{jobPost.companyName}}</td>

                            <td>{{jobPost.creationDate|date: 'mediumDate'}}</td>
                            <td><span *ngIf="jobPost.expirationDate; else notExists">{{jobPost.expirationDate|date: 'mediumDate'}}</span>
                            </td>

                            <td class="link" (click)="jobPostDetails(jobPost.uuid)">
                                Περισσότερες Πληροφορίες
                            </td>

                            <td style="width: 100%;">
                                <select (change)="onChange($event, jobPost.uuid)" class="form-control" id="sel1" name="sellist1" style="width: max-content;">
                                    <option value="pending">Εκκρεμής</option>
                                    <option value="approved">Εγκρίνεται</option>
                                    <option value="disapproved" selected>Απορρίπτεται</option>
                                </select>
                            </td>

                        </tr>
                    </tbody>
                </table>
                <p *ngIf="jobPostsData.length===0" style="margin-top: 20px;"> {{message}}</p>
            </div>

            <ng-template #notExists> - </ng-template>
        </div>
        <!-- Pagination-->
        <app-pagination-bs *ngIf="jobPosts" [initialPage]="currentPage + 1" [pageSize]="pageSize" [items]="jobPosts" (changePage)="onChangePage($event)"></app-pagination-bs>
    </div>
</div>

<!-- jobPostDetails modal -->
<div class="modal fade" id="jobPostDetailsModal" tabindex="-1 " role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 900px;" role="document">
        <div *ngIf="jobPost" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel ">Προεπισκόπηση Θέσης</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="layout-details">
                                    <h3 style="margin-bottom: 10px" id="title">{{jobPost.title}}</h3>

                                    <div class="row row-15 row-bordered">
                                        <div class="col-md-2 col-lg-2">
                                            <img *ngIf="jobPost.logo" class="img-thumbnail company-logo" src="{{jobPost.logo}}" alt="" />
                                            <img *ngIf="!jobPost.logo" class="img-thumbnail company-logo" src="assets/images/defaultcompanylogo.jpg" alt="" />
                                        </div>


                                        <div class="col-sm-12 col-12 col-md-5 col-lg-5 vertical-line">
                                            <ul class="list list-xs">
                                                <li>
                                                    <a>
                                                        <p><span class="icon icon-sm text-primary mdi mdi-city"></span>
                                                            <span class="context-break" placement="top-left" ngbTooltip="Επωνυμία εταιρείας">
                                                                {{jobPost.companyName}}</span>
                                                        </p>
                                                    </a>
                                                </li>

                                                <li>
                                                    <p><span class="icon text-primary mdi mdi-map-marker"></span><span class="context-break">{{jobPost.locationName}}</span>
                                                    </p>
                                                </li>

                                                <li>
                                                    <p><span class="icon text-primary mdi mdi-web"></span><span><a
                                                                class="context-break"
                                                                href="mailto:{{jobPost.email}}">{{jobPost.email}}</a></span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-5 col-lg-5">
                                            <ul class="list list-xs">
                                                <li>
                                                    <p><span class="icon text-primary mdi mdi-clock"></span><span>Ημ/νία
                                                            ανάρτησης:
                                                            {{jobPost.creationDate|date: 'mediumDate'}}</span>
                                                    </p>
                                                </li>
                                                <li>
                                                    <p><span class="icon text-primary mdi mdi-calendar-clock"></span> Ημ/νία λήξης:
                                                        <span *ngIf="jobPost.expirationDate; else notExists">{{jobPost.expirationDate|date: 'mediumDate'}}</span>
                                                    </p>
                                                    <ng-template #notExists>
                                                        -
                                                    </ng-template>
                                                </li>
                                                <li>
                                                    <p *ngIf="jobPost.salary"><span class="icon icon-sm text-primary mdi mdi-cash"></span>
                                                        <span>Μισθός:
                                                            {{jobPost.salary | currency:'EUR':true}}
                                                        </span>
                                                    </p>
                                                </li>
                                                <li>
                                                    <p class="object-inline object-inline_sm"><span class="icon icon-default text-primary mdi mdi-file-document"></span>{{jobPost.applications}} αιτήσεις
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p id="descriptionParagraph" class="text-style-1" [innerHtml]="jobPost.description | safe"></p>

                        <div class="row row-30">
                            <div class="col-md-6 col-lg-6">
                                <h4>Απαιτούμενα προσόντα</h4>
                                <div *ngIf="jobPost.prerequisites" class="listDiv" [innerHtml]="jobPost.prerequisites | safe">
                                </div>

                                <div *ngIf="!jobPost.prerequisites">
                                    <p>Δεν έχουν εισαχθεί απαιτούμενα προσόντα</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <h4>Προσφέρονται</h4>
                                <div class="listDiv" *ngIf="jobPost.benefits" [innerHtml]="jobPost.benefits | safe">

                                </div>
                                <div *ngIf="!jobPost.benefits">
                                    <p>Δεν έχουν εισαχθεί παροχές</p>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- confirm create admin modal -->
<div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{titleMessage}}</h5>

                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <h5 class="modal-title" id="exampleModalLabel"></h5>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{bodyMessage}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Ακύρωση</button>
                <button type="button" (click)="handlingMultipleJobPosts(selectedStatus)" class="btn btn-primary">Επιβεβαιωση</button>
            </div>
        </div>
    </div>
</div>